import { Text } from "@fluentui/react-components";
import MobileLink from "./MobileLink";
import INavigationArea from "../../../models/navigation/INavigationArea";
import INavigationSection from "../../../models/navigation/INavigationSection";

interface IMobileSection {
    area: INavigationArea;
    section: INavigationSection;
    onNavigate: () => void;
}

const MobileSection = (props: IMobileSection) => (
    <div>
        <Text block as="h3">
            {props.section.name}
        </Text>
        {
            props.section.links
                .map((link, index) => <MobileLink key={index} area={props.area.slug} link={link} onNavigate={props.onNavigate} />)
        }
    </div>
)

export default MobileSection;